// src/pages/hotelRoomCategories/EditHotelRoomCategory.jsx

import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditHotelRoomCategory from "../../components/hotelRoomCategories/FormAddEditHotelRoomCategory";
import useGetHotelRoomCategory from "../../hooks/hotelRoomCategories/useGetHotelRoomCategory";
import { CircularProgress, Box } from "@mui/material";

const EditHotelRoomCategory = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { isLoading, hotelRoomCategory } = useGetHotelRoomCategory(id);

    if (isLoading) {
        return (
            <WrapperSection>
                <Box display="flex" justifyContent="center" p={4}>
                    <CircularProgress />
                </Box>
            </WrapperSection>
        );
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditHotelRoomCategory
                isEdit={true}
                currentData={hotelRoomCategory}
                onSubmitSuccess={() => navigate("/hotel-room-categories")}
            />
        </WrapperSection>
    );
};

export default EditHotelRoomCategory;
